import {
    UNKNOWN_ALIAS,
    UNKNOWN_SIGNAL_TRANSLATABLE,
} from "app/pages/sales-intelligence/sub-modules/signals/constants/common";
import type IntentSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/intent/IntentSignalFilters";
import IntentSignalTemplate from "app/pages/sales-intelligence/sub-modules/signals/models/intent/IntentSignalTemplate";
import SignalTemplatesManager from "../../../models/templates/SignalTemplatesManager";
import SignalSource from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalSource";

export default class IntentSignalTemplatesManager extends SignalTemplatesManager<IntentSignalFilters> {
    getEmptyTemplate(): Readonly<IntentSignalTemplate> {
        return new IntentSignalTemplate({
            alias: UNKNOWN_ALIAS,
            signalSource: SignalSource.Platform,
            name: UNKNOWN_SIGNAL_TRANSLATABLE,
            description: UNKNOWN_SIGNAL_TRANSLATABLE,
            filters: {},
        });
    }

    getDefaultTemplate(): Readonly<IntentSignalTemplate> {
        const defaultTemplate = this.getTemplates().find(({ alias }) => alias === "intent-signal-alias");

        return defaultTemplate ?? this.getEmptyTemplate();
    }

    getTemplates(): readonly IntentSignalTemplate[] {
        return [
            new IntentSignalTemplate({
                alias: "intent-signal-alias",
                name: { key: "si.signals.templates.intent.name" },
                description: {
                    key: "si.signals.templates.intent.description",
                },
                signalSource: SignalSource.Platform,
                filters: {
                    topics: [],
                    countries: [],
                },
            }),
        ];
    }
}
